import { useEffect, useState, useRef } from 'react';
import { useSyncState } from 'shared/hooks/useSyncState';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle } from 'features/ui/model/uiSlice';
import { useNavigate } from 'react-router-dom';
import { DrawerShopDots } from 'widgets/shopDots/ui/DrawerShopDots';
import { useGetParticipantsQuery } from 'features/getParticipants/api/getParticipantsApi';
import { useGetConstantsQuery } from 'features/getParticipants/api/getConstantsApi';
import { useGetCitiesQuery } from 'features/getCities/api/getCitiesApi';
import { TableContentForMechanic } from 'entities/table/ui/TableContentForMechanic';
import { useDeleteShopMutation } from 'features/createParticipant/createParticipant';
import { Button } from '@mui/material';

const fields = [
  {
    field: 'id',
    title: 'ID',
    width: '5%',
  },
  {
    field: 'title',
    title: 'Наименование',
    width: '20%',
  },
  {
    field: 'city',
    title: 'Город',
    width: '10%',
  },
  {
    field: 'address',
    title: 'Адрес торговой точки',
    width: '10%',
  },
  {
    field: 'status',
    title: 'Статус',
    width: '10%',
  },
  {
    field: 'direction',
    title: 'Канал',
    width: '10%',
  },
  {
    field: 'tier',
    title: 'Уровень',
    width: '10%',
  },
  {
    field: 'door_code',
    title: 'Код двери',
    width: '10%',
  },
];

export const ShopDotsWidget = () => {
  const dispatch = useAppDispatch();
  const [pagination, setPagination] = useState<{
    page: number;
    count: number;
    search: string;
  }>({
    page: 1,
    count: 10,
    search: '',
  });
  const { data: shopDotsList } = useGetParticipantsQuery({
    page: pagination.page,
    size: pagination.count,
    search: pagination.search,
  });
  const { data: cityList } = useGetCitiesQuery({});
  const { data: constantsList } = useGetConstantsQuery(null);
  const [removeShopRequest] = useDeleteShopMutation();
  const navigate = useNavigate();

  const [isShowSearch, setIsShowSearch] = useState(false);
  const searchQuery = useSyncState('');
  const searchRef = useRef('');

  function handleSearch() {
    setPagination((prev) => ({
      ...prev,
      search: searchRef.current,
    }));
  }

  const handleSetSearch = (search: string) => {
    searchQuery.set(search);
    searchRef.current = search;
  };
  const handleClearSearch = () => {
    setIsShowSearch(false);
    searchQuery.set('');
    searchRef.current = '';
    setPagination((prev) => ({
      ...prev,
      search: '',
    }));
  };

  const mlist = { list: [] as any };

  if (shopDotsList && shopDotsList.items) {
    shopDotsList?.items.forEach((item) => {
      mlist.list.push({
        id: item.id,
        title: item.title,
        city: cityList?.find((citi) => citi.id === item.city_id)?.name,
        address: item.address,
        status: constantsList?.['SalesPoint.Status'].ACTIVE === item.status ? 'Активный' : 'Блокированный',
        direction:
          constantsList?.['SalesPoint.Direction'].DS === item.direction
            ? 'DS'
            : constantsList?.['SalesPoint.Direction'].KAM === item.direction
            ? 'KAM'
            : 'OP',
        door_code: item.door_code,
        tier:
          constantsList?.['SalesPoint.Tier'].LOW === item.tier
            ? 'LOW'
            : constantsList?.['SalesPoint.Tier'].TOP === item.tier
            ? 'TOP'
            : 'MIDDLE',
      });
    });
  }

  const handleDeleteShop = (id: number) => {
    removeShopRequest(id).then(() => {
      navigate('/shop-dots/');
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    });
  };

  const handleSelect = (id: number) => {
    navigate(`/shop-dots/${id}`);
  };

  useEffect(() => {
    dispatch(setHeaderTitle('Торговые точки'));
  }, [dispatch]);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <Button
          sx={{
            textTransform: 'none',
            marginRight: '30px',
            '.MuiSvgIcon-root': { color: '#fff !important' },
          }}
          size="large"
          variant="contained"
          onClick={() => navigate('/shop-dots/upload-dots')}
        >
          Загрузить ТТ
        </Button>
      </div>
      <TableContentForMechanic
        searchPlaceholder="Поиск по наименованию, городу, адресу"
        title="Список торговых точек"
        onSearch={() => handleSearch()}
        fields={fields}
        list={{ list: mlist.list }}
        count={shopDotsList?.total ?? 0}
        page={pagination.page - 1}
        perPage={pagination.count}
        onPageChange={(_, page) => {
          setPagination((prev) => ({
            ...prev,
            page: page + 1,
          }));
        }}
        onRowsPerPageChange={(e) => {
          setPagination(() => ({
            page: 1,
            count: parseInt(e.target.value),
            search: pagination.search,
          }));
        }}
        isShowSearch={isShowSearch}
        onShowSearch={(showSearch) => setIsShowSearch(showSearch)}
        onClearSearch={handleClearSearch}
        search={searchQuery.get()}
        setSearch={handleSetSearch}
        onRowClick={handleSelect}
        onDeleteClick={handleDeleteShop}
        onChangeClick={() => {}}
      />
      <DrawerShopDots />
    </div>
  );
};
